var __vue_script__, __vue_template__
var __vue_styles__ = {}
require("!!./../../../../.1.0.1@extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!./../../../../.8.7.0@vue-loader/lib/style-rewriter.js!less-loader?sourceMap!./../../../../.8.7.0@vue-loader/lib/selector.js?type=style&index=0!./index.vue")
__vue_script__ = require("!!babel-loader?presets[]=es2015&plugins[]=transform-runtime&comments=false!./../../../../.8.7.0@vue-loader/lib/selector.js?type=script&index=0!./index.vue")
__vue_template__ = require("!!vue-html-loader!./../../../../.8.7.0@vue-loader/lib/selector.js?type=template&index=0!./index.vue")
module.exports = __vue_script__ || {}
if (module.exports.__esModule) module.exports = module.exports.default
var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
if (__vue_template__) {
__vue_options__.template = __vue_template__
}
if (!__vue_options__.computed) __vue_options__.computed = {}
Object.keys(__vue_styles__).forEach(function (key) {
var module = __vue_styles__[key]
__vue_options__.computed[key] = function () { return module }
})



//////////////////
// WEBPACK FOOTER
// ./~/.0.1.3@vux/src/components/search/index.vue
// module id = 528
// module chunks = 2